(function () {
    'use strict';

    angular.module("imApp").factory("poMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getProductionOrderMenu: function (parms) {
                return $ihttp.post({
                    method: 164,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
